export default __webpack_public_path__ + "static/media/down-arrow-ylw.e2978494.svg";